import { Component, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { takeUntil } from 'rxjs/operators';
import { Unsubscribe } from 'src/app/core';
import { luhnValidator } from 'src/app/core/form-validators/luhn.validator';
import { LinesService } from 'src/app/core/proto/whitepages/lines';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-end-users-sim-swap-form',
  templateUrl: './end-users-sim-swap-form.component.html',
  styleUrls: ['./end-users-sim-swap-form.component.less'],
})
export class EndUsersSimSwapFormComponent
  extends Unsubscribe
  implements OnInit
{
  simSwapForm: FormGroup;
  SIMS_PREFIX = 'PAGE.MOBILE.END_USERS.OVERVIEW.SIMS';
  isSubmitting: boolean = false;
  @Input() lineId: string;
  @Input() oldIccid: string;

  constructor(
    private notificationService: NotificationService,
    private linesService: LinesService,
    private fb: FormBuilder,
    private drawerRef: NzDrawerRef<string>
  ) {
    super();
    this.simSwapForm = this.fb.group(this.simSwapFormModel());
  }

  ngOnInit(): void {
    this.simSwapForm.get('oldIccid').setValue(this.oldIccid);
  }

  getStrPath(path) {
    return `${this.SIMS_PREFIX}.${path}`;
  }

  simSwapFormModel(): any {
    return {
      oldIccid: [
        { value: this.oldIccid, disabled: true },
        [Validators.required],
      ],
      newIccid: [
        null,
        [Validators.required, luhnValidator(), Validators.minLength(19)],
      ],
    };
  }

  /**
   * Submit Form
   */
  submitForm(): void {
    this.isSubmitting = true;

    this.linesService
      .simSwap(this.lineId, {
        lineId: this.lineId,
        currentIccid: this.simSwapForm.get('oldIccid').value,
        newIccid: this.simSwapForm.get('newIccid').value,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => {
          this.isSubmitting = false;

          this.notificationService.success(
            'MESSAGE.SUCCESS',
            this.getStrPath('FORM_SIM_SWAP.SUCCESS_MESSAGE')
          );
          this.drawerRef.close({ reloadData: true });
        },
        () => (this.isSubmitting = false)
      );
  }
}
